import { render } from "./CommunityCommentSignupAppeal.vue?vue&type=template&id=74701649"
import script from "./CommunityCommentSignupAppeal.vue?vue&type=script&lang=js"
export * from "./CommunityCommentSignupAppeal.vue?vue&type=script&lang=js"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__